<template>
  <el-table-column
    prop="completion_date"
    sortable="custom"
    label="Kelt"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.completion_date | dateTime }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'completion_date',
  };
</script>
